// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpChartLegendItemProps = {
    color: string;
    value: number;
    label: string;
};

export const WebpChartLegendItem: FunctionComponent<WebpChartLegendItemProps> = ({ color, value, label }) => {
    const renderedValue = value > 0 ? value : "-";

    return (
        <Container className="webp-chart-legend-item" color={color}>
            <div className="legend-item">
                <span className="dot" />

                <span className="label">
                    {renderedValue} {label}
                </span>
            </div>
        </Container>
    );
};
